import React from "react"

const Item = ({ title, lang, link, image }) => (
    <div className="item">
      <div className="item-info">
        <div>
          <h3>{title}</h3>
          <p>Built with: {lang}</p>
        </div>
        <a href={link}>View</a>
      </div>
      <img src={image} alt={title} />
    </div>
)

export default Item;